import { getDeferred } from './get-deferred';

export const waitForElement = (
  cssSelector: string,
  timeoutMs = 10000,
  throwWhenMissing = false
): Promise<HTMLElement | null> => {
  const getter = (): HTMLElement | null => document.querySelector(cssSelector);
  const syncCheckResult = getter();

  // If it already exists don't bother setting up periodical checks
  if (syncCheckResult) {
    return Promise.resolve(syncCheckResult);
  }

  const deferred = getDeferred<HTMLElement | null>();
  let timeout: ReturnType<typeof setTimeout> = NaN;

  const interval = setInterval(() => {
    const maybeElement = getter();
    if (maybeElement !== null) {
      deferred.resolve(maybeElement);
      clearInterval(interval);
      clearTimeout(timeout);
    }
  }, 50);

  timeout = setTimeout(() => {
    clearInterval(interval);
    // Sometimes `null` is good enough result
    if (throwWhenMissing) {
      deferred.reject(
        new Error(
          `Failed to locate element with CSS selector ${cssSelector} within ${timeoutMs} milliseconds.`
        )
      );
    } else {
      deferred.resolve(null);
    }
  }, timeoutMs);

  return deferred.promise;
};
